import * as React from 'react';
import './App.css';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Routes from '../Routes';
import { Auth } from 'aws-amplify';

class App extends React.Component {
  state: any;
  constructor(props: any) {
    super(props);
    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      dark: false,
      theme: () => createMuiTheme({
        typography: {
          useNextVariants: true,
        },
        palette: {
          primary: {
            main: "#0F75BC"
          },
          type: 'light', // Switching the dark mode on is a single property value change.
        }
      })}
  }

  userHasAuthenticated = (authenticated: boolean): void => {
    this.setState({ isAuthenticated: authenticated });
  }


  handleLogout = async (event: any): Promise<any> => {
    await Auth.signOut();
    this.userHasAuthenticated(false);
    this.handleThemeChange(false);
    this.setState({dark: false});
  }

  handleThemeChange = (dark: boolean) => {
    let newTheme: any;
    if(dark) {
        newTheme = createMuiTheme({
          typography: {
            useNextVariants: true,
          },
          palette: {
            primary: {
              main: "#0F75BC"
            },
            type: 'dark', // Switching the dark mode on is a single property value change.
          }
        });
    } else {
        newTheme = createMuiTheme({
          typography: {
            useNextVariants: true,
          },
          palette: {
            primary: {
              main: "#0F75BC"
            },
            type: 'light', // Switching the dark mode on is a single property value change.
          }
        });
    }
    this.setState({
      dark: !this.state.dark,
      theme: newTheme
    })
  }

  async componentDidMount() {
    try {
      await Auth.currentSession();
      this.userHasAuthenticated(true);
    }
    catch(e) {
      if (e !== 'No current user') {
        alert(e);
      }
    }

    this.setState({ isAuthenticating: false });
  }

  public render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      handleLogout: this.handleLogout,
      handleThemeChange: this.handleThemeChange
    };
    return (
      !this.state.isAuthenticating &&
      <MuiThemeProvider theme={this.state.theme}>
        <Routes childProps={childProps}/>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.tsx